import Api from "./Api";
import { createQueryString } from "./ApiHelper";
export default {
  GetBookingDetails(payload) {
    // console.log(payload);
    return Api().post(`/api/pos/pickup-ticket`, payload);
  },

  userpasswordconfirm(payload) {
    return Api().post(`/userslogin`, payload);
  },
  updateSeatOccupancy(payload) {
    return Api().post(`/api/qr-code/update-seat-status-qr-code`, payload);
  },

  GetGlobalOptions() {
    return Api().get(`/global_options`);
  },
  GetShowTimesList(payload) {
    const query = createQueryString(payload);
    return Api().get(`/api/qr-code/all-confirmed-movies-schedules/${query}`);
  },

  validateEntryId(payload) {
    return Api().get(`/api/qr-code/validate-entry-id/${payload.entry_id}`);
  },

  GetActiveList(payload) {
    let query = "";
    let length = Object.keys(payload).length;
    if (length > 0) {
      query = "?";
      Object.keys(payload).map((x, index) => {
        if (x !== "tableName") {
          query +=
            index === length - 1 ? `${x}=${payload[x]}` : `${x}=${payload[x]}&`;
        }
      });
    }
    return Api().get(`/api/admin/tablelist/${payload.tableName}${query}`);
  }

  //   BookingDetails(payload) {
  //     return Api().post(`api/end/point/`, payload);
  //   }
};



// WEBPACK FOOTER //
// ./src/services/BookingService.js